import React from 'react';

import PropTypes from 'prop-types';
import { Label, Table } from 'semantic-ui-react';

import _isArray from 'lodash/isArray';
import _isBoolean from 'lodash/isBoolean';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _isObject from 'lodash/isObject';
import _isString from 'lodash/isString';
import _startCase from 'lodash/startCase';

import DateUtils from 'libs/date-utils';

import {
  DATE_FIELD_NAME,
  TIME_FIELD_NAME,
  DATE_TIME_FIELD_NAME,
} from '../../../../custom-pages/constants/form';
import { NOT_PROVIDED_VALUE } from '../CustomerSubmissionsModal.constants';

const propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.array,
    PropTypes.object,
  ]),
  inputType: PropTypes.string,
  widgetType: PropTypes.string,
};

const defaultProps = {
  fieldValue: null,
  inputType: null,
  widgetType: null,
};

export default function CustomerSubmissionsModalTableRow({
  fieldName,
  fieldValue,
  inputType,
  widgetType,
}) {
  const label = _startCase(fieldName);

  const renderMap = [
    {
      check: _isNil,
      render: () => NOT_PROVIDED_VALUE,
    },
    {
      check: () => inputType === DATE_FIELD_NAME && widgetType === 'input' && _isString(fieldValue),
      render: () =>
        !_isEmpty(fieldValue) ? DateUtils.format(fieldValue, 'MMMM D, YYYY') : 'NO DATE PROVIDED',
    },
    {
      check: () => inputType === TIME_FIELD_NAME && widgetType === 'input' && _isString(fieldValue),
      render: () =>
        !_isEmpty(fieldValue)
          ? DateUtils.format(`2000-01-01T${fieldValue}`, 'h:mm A')
          : 'NO DATE PROVIDED',
    },
    {
      check: () =>
        inputType === DATE_TIME_FIELD_NAME && widgetType === 'input' && _isString(fieldValue),
      render: () =>
        !_isEmpty(fieldValue)
          ? DateUtils.format(fieldValue, 'MMMM D, YYYY [at] h:mm A')
          : 'NO DATE PROVIDED',
    },
    {
      check: _isBoolean,
      render: () => (fieldValue ? 'True' : 'False'),
    },
    {
      check: (value) => _isString(value),
      render: () => {
        return fieldValue.split('\n').map((part, index, array) => {
          return (
            <>
              {part}
              {index < array.length - 1 && <br />}
            </>
          );
        });
      },
    },
    {
      check: (value) => _isNumber(value),
      render: () => fieldValue.toString(),
    },
    {
      check: _isArray,
      render: () =>
        fieldValue.map((item) => {
          const itemValue = _isString(item) ? item : JSON.stringify(item);
          return (
            <Label basic key={`${fieldName}-${itemValue}`}>
              {itemValue}
            </Label>
          );
        }),
    },
    {
      check: _isObject,
      render: () =>
        Object.entries(fieldValue).map(([subfieldName, subValue]) => (
          <CustomerSubmissionsModalTableRow
            key={subfieldName}
            fieldName={subfieldName}
            fieldValue={subValue}
          />
        )),
    },
  ];

  // Find the first matching render function based on the conditions
  const renderFieldValue = () => {
    const { render } = renderMap.find(({ check }) => check(fieldValue)) || {};
    return render ? render() : '';
  };

  return (
    <Table.Row>
      <Table.Cell width={4}>{label}</Table.Cell>
      <Table.Cell>{renderFieldValue()}</Table.Cell>
    </Table.Row>
  );
}

CustomerSubmissionsModalTableRow.propTypes = propTypes;
CustomerSubmissionsModalTableRow.defaultProps = defaultProps;
